import { render, staticRenderFns } from "./WidgetViewer.vue?vue&type=template&id=66befc2e&scoped=true&v-slot%3Afooter=true&"
import script from "./WidgetViewer.vue?vue&type=script&lang=ts&"
export * from "./WidgetViewer.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetViewer.vue?vue&type=style&index=0&id=66befc2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66befc2e",
  null
  
)

export default component.exports